import * as angular from 'angular';

import * as NumberAndDashOnly from 'common/source/directives/number-and-dash-only';
import * as NumberOnly from 'common/source/directives/number-only';
import * as InvalidZipcode from 'common/source/directives/invalid-zipcode';
import * as LimitLength from 'common/source/directives/limit-length';

const module = angular.module('customerPortalDirectives', [
    NumberAndDashOnly.module.name,
    NumberOnly.module.name,
    InvalidZipcode.module.name,
    LimitLength.module.name
]);

export { module };
